import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-062c5c8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-content p-2 d-flex flex-wrap overflow-auto" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src", "onLoad"]
const _hoisted_4 = { class: "feature-text2 mt-1" }
const _hoisted_5 = { class: "feature2-title" }
const _hoisted_6 = { class: "feature2-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.features, (feature, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["features2 my-2 d-flex", [(Number(index)%2) === 0? 'ms-2 me-3': 'mr-2']]),
        onClick: ($event: any) => (feature.url?$setup.jumpUrl(feature.url,feature.id):null),
        role: "button",
        key: index
      }, [
        _createElementVNode("img", {
          class: _normalizeClass(["feature-icon2 me-2 rounded-8-px", [($setup.state.loadingFeatures || !feature.load) ? 'animation-icon2' : '']]),
          src: feature.load?feature?.image_link ?? '' : $setup.featureLoadingIcon_,
          onError: _cache[0] || (_cache[0] = ($event: any) => ($setup.onIconFeatureError($event))),
          onLoad: ($event: any) => ($setup.onIconFeatureLoading(feature.id)),
          alt: "feature"
        }, null, 42, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(feature?.title??$setup.local.feature_title), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(feature?.desc??$setup.local.feature_desc), 1)
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}